import { render, staticRenderFns } from "./SomethingWentWrong.vue?vue&type=template&id=f660999e&scoped=true&"
import script from "./SomethingWentWrong.vue?vue&type=script&lang=js&"
export * from "./SomethingWentWrong.vue?vue&type=script&lang=js&"
import style0 from "./SomethingWentWrong.vue?vue&type=style&index=0&id=f660999e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f660999e",
  null
  
)

export default component.exports